import { styled } from '@linaria/react';

export const ReviewsFetch = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 3.125rem 0;
  font-size: 0.875rem;
  svg {
    margin-right: 0.5rem;
  }
  button {
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    color: inherit;
    text-decoration: underline;
    text-transform: lowercase;
    cursor: pointer;
  }
`;
